let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cjEpc")).then(() => parcelRequire('4wXd5'));